export function mapRecordToList
  <R extends {}, K extends keyof R, V extends R[K], MappedValue>
  (record: R, map: (key: K, value: V) => MappedValue)
{
  return (Object.entries(record) as [K, V][])
          .map(([key, value]) => map(key, value)) as MappedValue[]
}